import React from 'react'
import { graphql, HeadProps, PageProps } from 'gatsby'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'

import { SEO } from '../components/SEO'
import { Container } from '../components/Container'
import { Section } from '../components/Section'
import { BaseLayout } from '../layouts/Base'
import { Hero } from '../components/Hero'
import { Heading } from '../components/Heading'
import { JobsList } from '../components/JobsList'
import { useEmployeeStories } from '../hooks/useEmployeeStories'
import { EmployeeStoriesList } from '../components/EmployeeStoriesList'
import { ContactUs } from '../sections/ContactUs'

const ServicesTemplate = ({ data }: PageProps<Queries.CareerTemplateQuery>) => {
  const { page, jobs } = data!
  const { pageHero, careerPage } = page!
  const { gallery } = careerPage!
  const { employeeStories } = useEmployeeStories()

  return (
    <BaseLayout>
      <Section>
        <Container>
          {pageHero && (
            <div className="mb-12">
              <Hero
                heroTitle={pageHero?.heroTitle}
                image={pageHero?.image?.gatsbyImage}
              />
            </div>
          )}

          <div className="grid gap-8">
            <Heading as="h1">Volné pozice</Heading>

            <JobsList jobs={jobs.nodes} />
          </div>
        </Container>
      </Section>

      {gallery && (
        <Section>
          <Container>
            <div className="grid gap-2 grid-cols-2 lg:grid-cols-4">
              {gallery.map(
                (
                  image: {
                    readonly gatsbyImage: IGatsbyImageData | null
                  } | null,
                  index: number,
                ) => {
                  if (image && image.gatsbyImage) {
                    return (
                      <GatsbyImage
                        className={`overflow-hidden rounded leading-[0] text-[0px] ${
                          index === gallery.length - 1
                            ? 'col-span-2 lg:col-span-4'
                            : ''
                        }`}
                        image={image.gatsbyImage}
                        alt=""
                      />
                    )
                  }

                  return null
                },
              )}
            </div>
          </Container>
        </Section>
      )}

      {employeeStories && (
        <Section id="pribehy">
          <Container>
            <div className="grid gap-8">
              <Heading as="h2">Příběhy našich zaměstnanců</Heading>

              <EmployeeStoriesList stories={employeeStories} />
            </div>
          </Container>
        </Section>
      )}

      <ContactUs />
    </BaseLayout>
  )
}

export const query = graphql`
  query CareerTemplate($id: String) {
    page: wpPage(id: { eq: $id }) {
      id
      title
      content
      pageHero {
        heroTitle
        image {
          gatsbyImage(width: 1920)
        }
      }
      careerPage {
        gallery {
          gatsbyImage(width: 1280, placeholder: BLURRED)
        }
      }
    }
    jobs: allWpJob {
      nodes {
        id
        title
        slug
        excerpt
      }
    }
  }
`

export default ServicesTemplate

export const Head = ({ data }: HeadProps<Queries.CareerTemplateQuery>) => {
  const { page } = data!

  return <SEO title={page!.title!} description={page!.content!} />
}
